import { ReactElement, useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
// import * as Sentry from '@sentry/browser';
import { useTheme } from 'styled-components';

import request from 'app/utils/request';
import useStorage from 'app/utils/storage';

import { SchoolAutoDiscoverProps, SchoolAutoDiscoverApiResponse, setSchoolProcess } from 'features/school';
import { Loading } from 'components';
import { formatDate } from 'app/utils';
import useSchool from './useSchool';

import fakeSchoolDiscover from '../../fakeSchoolDiscover.json';

const { REACT_APP_SAVE_DISCOVER } = process.env;
const { REACT_APP_UNSECURE_COOKIE } = process.env;
const { REACT_APP_API_GATEWAY_URL } = process.env;

const SchoolDiscover = ({ children }: SchoolAutoDiscoverProps): ReactElement => {
  const storage = useStorage('localStorage');

  const [loading, setLoading] = useState(true);
  const [, setCookie] = useCookies(['autoDiscover']);
  const { schoolUuid, schoolAlias } = useSchool();
  // const { setSchoolColors } = useTheme();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setTheme } = useTheme();

  useEffect(() => {
    // const schoolFromCookie = cookies.autoDiscover;

    // if (schoolFromCookie) {
    //   setLoading(false);
    //   dispatch(setSchoolProcess(schoolFromCookie));
    // } else {
    request(
      {
        url: '/api/v1/School/AutoDiscover',
        baseURL: process.env.NODE_ENV === 'production' ? window.location.origin : REACT_APP_API_GATEWAY_URL,
        method: 'POST',
        data: {
          host: window.location.host,
        },
      },
      true
    )
      .then((response: AxiosResponse<SchoolAutoDiscoverApiResponse>) => {
        setLoading(false);

        let autoDiscover = response.data;

        if (process.env.NODE_ENV === 'development' && Object.keys(fakeSchoolDiscover)?.length) {
          autoDiscover = fakeSchoolDiscover as unknown as SchoolAutoDiscoverApiResponse;
        }

        if (REACT_APP_SAVE_DISCOVER === 'true') {
          const unsecureCookie = REACT_APP_UNSECURE_COOKIE === 'true' || window.location.hostname === 'localhost';
          setCookie('autoDiscover', autoDiscover, {
            path: '/',
            domain: window.location.hostname,
            expires: formatDate().add({ hour: 6 }).toDate(),
            secure: !unsecureCookie,
          });
        }

        // Sentry.setTag('school', response.data.schoolAlias);

        // const PRIMARY_COLOR_400 = response.data.uiSettings.primaryColor;
        // const PRIMARY_COLOR_200 = lightenColor(PRIMARY_COLOR_400, 10);
        // const PRIMARY_COLOR_600 = darkenColor(PRIMARY_COLOR_400, 10);

        // const SECONDARY_COLOR_400 = response.data.uiSettings.secondaryColor;
        // const SECONDARY_COLOR_300 = lightenColor(SECONDARY_COLOR_400, 10);
        // const SECONDARY_COLOR_600 = darkenColor(SECONDARY_COLOR_400, 10);

        // setSchoolColors({
        //   primary_200: PRIMARY_COLOR_200,
        //   primary_400: PRIMARY_COLOR_400,
        //   primary_600: PRIMARY_COLOR_600,
        //   primary_contrast: getContrast(PRIMARY_COLOR_400),

        //   secondary_300: SECONDARY_COLOR_300,
        //   secondary_400: SECONDARY_COLOR_400,
        //   secondary_600: SECONDARY_COLOR_600,
        //   secondary_contrast: getContrast(SECONDARY_COLOR_400),
        // });

        dispatch(setSchoolProcess(autoDiscover));
      })
      .catch((e) => {
        setLoading(false);
        navigate('/school-not-found');
      });
    // }
  }, []);

  useEffect(() => {
    if (schoolAlias === 'b3') {
      const initialTheme = storage.get('currentTheme') || 'light';
      setTheme(initialTheme);
    }
  }, [schoolAlias]);

  if (loading || !schoolUuid) return <Loading label="Por favor, aguarde." />;

  return <>{children}</>;
};

export default SchoolDiscover;
